module.exports = __webpack_public_path__ + "img/nonetwork.4ffd2a18.png";